import { ToggleType } from '@wix/rules-panel-ui';
import { useSetAtom } from 'jotai';
import { useCallback, useEffect, useState } from 'react';
import { currentTaskInfoAtom } from '../../../../../atoms/bi-atoms';
import { SITE_LEVEL_PAGE_ID } from '../../../../../consts';
import { AnalysisState, usePanelStateAtom } from '../../../../../hooks/rules-state';
import { useQueryRuleExecutionResultsQuery } from '../../../../../queries/use-query-rule-execution-results-query';
import { useBasePageGroup } from '../use-base-page-group';
import { useSiteLevelRuleResults } from './use-site-level-rule-results';
export const useSiteLevelPageGroup = () => {
  const {
    refetch: refetchRuleExecutionResults
  } = useQueryRuleExecutionResultsQuery(SITE_LEVEL_PAGE_ID, () => {});
  const {
    getGroupData
  } = usePanelStateAtom();
  const setCurrentTaskInfo = useSetAtom(currentTaskInfoAtom);
  const [isGroupOpen, setIsGroupOpen] = useState(false);
  const groupData = getGroupData(SITE_LEVEL_PAGE_ID);
  if (!groupData) {
    throw new Error(`Group data not found for pageId: ${SITE_LEVEL_PAGE_ID}.`);
  }
  const {
    itemType,
    analysisState
  } = groupData;
  const onGroupToggle = useCallback((toggleType, groupIndex) => {
    if (toggleType === ToggleType.Expand) {
      setIsGroupOpen(true);
    } else if (toggleType === ToggleType.Collapse) {
      setIsGroupOpen(false);
    }
    setCurrentTaskInfo(taskInfo => ({
      ...taskInfo,
      page_id: SITE_LEVEL_PAGE_ID,
      page_index: groupIndex,
      page_type: itemType
    }));
  }, [itemType, setCurrentTaskInfo]);

  // Auto-fetch when group is open and results become pending
  useEffect(() => {
    if (isGroupOpen && analysisState === AnalysisState.AnalyzeDonePendingResults) {
      refetchRuleExecutionResults();
    }
  }, [analysisState, isGroupOpen, refetchRuleExecutionResults]);
  const ruleResults = useSiteLevelRuleResults();
  const {
    ruleGroupProps
  } = useBasePageGroup({
    onGroupToggleCallback: onGroupToggle,
    pageId: SITE_LEVEL_PAGE_ID,
    ruleResults
  });
  return {
    siteLevelPageGroupProps: ruleGroupProps
  };
};
//# sourceMappingURL=use-site-level-page-group.js.map